import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, BoxProps } from '@mui/material';
import Locations from 'assets/img/cards/locations.png';
import Trust from 'assets/img/cards/trust.png';
import Proof from 'assets/img/cards/proof.png';
import Rocket from 'assets/img/cards/rocket.png';
import Idea from 'assets/img/cards/idea.png';
import Certificate from 'assets/img/cards/certificate.png';
import Webshop from 'assets/img/cards/webshop.png';
import Media from 'assets/img/cards/media-items.png';
import EmptySearch from 'assets/img/cards/empty-search.png';
import MapLayers from 'assets/img/cards/map-layers.png';
import ChainMapping from 'assets/img/cards/chain-mapping.png';
import { EIllustrationTypes } from 'DesignSystem/types/background.types';

const StyledImg = styled('img')(() => ({
  display: 'block',
}));

interface IProps {
  image: EIllustrationTypes;
  width?: number;
  height?: number;
}

const CardIllustration: React.FC<IProps & BoxProps> = ({
  image,
  width = '100%',
  height,
  ...props
}) => {
  return (
    <Box position="relative" {...props}>
      <StyledImg alt={`card-${image}`} src={getImage(image)} width={width} height={height} />
    </Box>
  );
};

export default CardIllustration;

const getImage = (imageName: EIllustrationTypes) => {
  return {
    LOCATIONS: Locations,
    TRUST: Trust,
    PROOF: Proof,
    ROCKET: Rocket,
    IDEA: Idea,
    CERTIFICATE: Certificate,
    WEBSHOP: Webshop,
    MEDIA: Media,
    EMPTY_SEARCH: EmptySearch,
    MAP_LAYERS: MapLayers,
    CHAIN_MAPPING: ChainMapping,
  }[imageName];
};
